import React from "react";

// Announcement ribbon; hides itself automatically after the end date.
const RIBBON_END = Date.parse("2026-11-07T05:00:00Z"); // end of Nov 6, 2026 ET

export const SiteRibbon: React.FC = () => {
  if (Date.now() >= RIBBON_END) return null;
  return (
    <div className="relative z-[60] bg-accent text-accent-foreground text-center text-sm font-medium px-4 py-2">
      TrustScale Acquires RagMetrics, Expanding its portfolio.{" "}
      <a href="/en/news/trustscale-acquires-ragmetrics" className="underline underline-offset-2 font-semibold hover:opacity-80">
        Read more
      </a>
    </div>
  );
};
